module.exports = __webpack_public_path__ + "static/media/icon_215.19b18b32.svg";